import { ROUTES as defaultRoutes } from '../../../default/routes.ts';
const ROUTES = {
  ...defaultRoutes,
  HELP_CENTRE: {
    ...defaultRoutes.HELP_CENTRE,
    BASE_URL: 'https://help.kenogo.com.au/',
    CONTACT_US: 'https://kenogo.custhelp.com/app/ask',
    CHAT: 'https://help.kenogo.com.au/embed/lopetto/',
  },
  MY_ACCOUNT: {
    ...defaultRoutes.MY_ACCOUNT,
    CLOSE_ACCOUNT: {
      CONTACT_US: 'https://kenogo.custhelp.com/app/ask',
      RESPONSIBLE_GAMBLING: '/responsible-gambling',
    },
    // TODO: WEBD-408 KenoGO Help Centre may have a new URL
    UPLOAD_DOCUMENTS: 'https://kenogo.custhelp.com/app/documents',
  },
  NAVIGATION: {
    LIVE_DRAW: '/live',
    PLAY: '/play',
    JACKPOT: '/play/jackpot',
    CLASSIC: '/play/classic',
    HEAD_OR_TAILS: '/play/heads-or-tails',
    RESULTS: defaultRoutes.RESULTS,
    PROMOTIONS: '/promotions',
    PARTNERSHIPS: '/partnerships',
    MAGAZINE: '/magazine',
  },
  // KenoGO has no casino, lotteries or sportsbook lobbies: /play lists the Keno games and The Daily Million
  PRODUCT_BROWSE: {
    GAMES: '/play',
    LOTTERIES: '/play',
    SPORTSBOOK: defaultRoutes.HOME,
  },
  FOOTER: {
    ...defaultRoutes.FOOTER,
    CONTACT: {
      PHONE: 'tel:1800867171',
      EMAIL: 'mailto:support@kenogo.com.au',
    },
    LEGAL: {
      ...defaultRoutes.FOOTER.LEGAL,
      TERMS: '/terms-and-conditions',
      // TODO: WEBD-408 KenoGO Help Centre may have a new URL
      DOCUMENTS: 'https://kenogo.custhelp.com/app/documents',
    },
    NAVIGATION: {
      ...defaultRoutes.FOOTER.NAVIGATION,
      EXPLORE: {
        LIVE_DRAW: '/live',
        CLASSIC: '/play/classic',
        JACKPOT: '/play/jackpot',
        HEAD_OR_TAILS: '/play/heads-or-tails',
        THE_DAILY_MILLION: '/lotteries/the-daily-million',
        LOTTERY_RESULTS: '/results',
      },
      LEARN: {
        ABOUT_KENOGO: '/about-kenogo',
        COMMUNITY_PARTNERSHIPS: '/partnerships',
        KENOGO_WINNERS: '/winners',
        HOW_TO_PLAY: '/how-to-play',
        FAQ: '/faq',
        APPS: '/apps',
      },
      LEGAL: {
        TERMS: '/terms-and-conditions',
        GAMBLE_SAFELY: '/responsible-gambling',
        PRIVACY: '/privacy-policy',
        MARKETING_MESSAGES: '/marketing-messages',
        KENOGO_RULES: '/kenogo-rules',
        LOTTERY_RULES: '/lottery-rules',
      },
      GAMBLE_SAFELY: {
        ...defaultRoutes.FOOTER.NAVIGATION.GAMBLE_SAFELY,
        GAMBLE_SAFELY: '/responsible-gambling',
      },
    },
    RESPONSIBLE_GAMING: {
      GAMBLERS_HELP: 'https://gamblershelp.com.au/',
      RESET_APP: 'https://resetapp.com.au/',
      NT_INTERNET_GAMING_CODE: 'https://nt.gov.au/industry/gambling/gambling/gambling-codes-of-practice/nt-internet-gaming-code-of-practice-harm-minimisation-2025',
    },
    SOCIALS: {
      INSTAGRAM: 'https://www.instagram.com/kenogoau/',
      FACEBOOK: 'https://www.facebook.com/kenogo.au/',
    },
    DOWNLOAD_THE_APP: {
      APP_STORE: 'https://app.adjust.com/fve5u4h',
      GOOGLE_PLAY: 'https://app.adjust.com/fve5u4h',
    },
  },
  MILLIONAIRE_EXPERIENCE: '/millionaire-experience',
  REGISTER_REDIRECTION: '/my-account/profile',
  REGISTER_REDIRECTION_SUCCESS: '/my-account/profile?registration-success=true',
  FALLBACK_URL: 'https://www.kenogo.com.au/',
} as const;

export { ROUTES };
